import React from "react";

export default function InboxToolbar({
  conversationsCount = 0,
  unreadCount = 0,
  subscribersCount = 0,
  metaConnected = true,
  providerLabel = "Interakt Connected",
  refreshing = false,
  onRefresh,
  onNewChat,
}) {
  return (
    <header className="wa-top-toolbar" role="toolbar" aria-label="WhatsApp Inbox Toolbar">
      {/* Brand & Connection Status */}
      <div className="wa-toolbar-left">
        <div className="wa-toolbar-brand">
          <i className="bi bi-whatsapp wa-brand-icon"></i>
          <span className="wa-brand-text">WhatsApp Inbox</span>
        </div>

        <div
          className={`wa-api-status-pill ${metaConnected ? "connected" : "warning"}`}
          title={metaConnected ? `${providerLabel} is active` : "Connecting API..."}
        >
          <span className="wa-status-dot"></span>
          <span className="wa-status-label">
            {metaConnected ? providerLabel : "Connecting API..."}
          </span>
        </div>
      </div>

      {/* Center Summary Stats */}
      <div className="wa-toolbar-center">
        <div className="wa-stat-item">
          <span className="wa-stat-val">{conversationsCount}</span>
          <span className="wa-stat-lbl">Conversations</span>
        </div>
        <span className="wa-stat-sep">•</span>
        <div className="wa-stat-item">
          <span className={`wa-stat-val ${unreadCount > 0 ? "unread" : ""}`}>{unreadCount}</span>
          <span className="wa-stat-lbl">Unread</span>
        </div>
        <span className="wa-stat-sep">•</span>
        <div className="wa-stat-item">
          <span className="wa-stat-val gold">{subscribersCount}</span>
          <span className="wa-stat-lbl">Subscribers</span>
        </div>
      </div>

      {/* Right Action Tools */}
      <div className="wa-toolbar-right">
        <button
          type="button"
          className={`wa-btn-icon-refresh ${refreshing ? "spinning" : ""}`}
          onClick={onRefresh}
          title="Refresh All Chats"
          disabled={refreshing}
          aria-label="Refresh"
        >
          <i className="bi bi-arrow-clockwise"></i>
        </button>

        <button
          type="button"
          className="wa-btn-new-chat-top"
          onClick={onNewChat}
          title="Start conversation with a new number"
        >
          <i className="bi bi-plus-lg me-1"></i>
          <span>New Chat</span>
        </button>
      </div>
    </header>
  );
}
